// ------------------------------------
// ShoppingcartReducer
// ------------------------------------
export const SET_NEW_SHOPPINGCART = 'SHOPPINGCART/SET_NEW_SHOPPINGCART';
export const SET_SHOPPINGCART = 'SHOPPINGCART/SET_SHOPPINGCART';
